export const LOGIN = "LOGIN"
export const GOOGLE_LOGIN = "GOOGLE_LOGIN"
export const GO_CASE_DETAIL = "GO_CASE_DETAIL"
export const GO_CASE_DEV = "GO_CASE_DEV"
export const GO_FUN = "GO_FUN"
export const CHECK_IS_MOBILE = "CHECK_IS_MOBILE"
